// removed by extract-text-webpack-plugin
module.exports = {"bullets-sidebar":"style_bullets-sidebar--3CqbG9Ce","bulletsSidebar":"style_bullets-sidebar--3CqbG9Ce","bullets-page":"style_bullets-page--1z8csBbI","bulletsPage":"style_bullets-page--1z8csBbI","num":"style_num--2Qh0aYZ5","content":"style_content--H0M2H1pK","tabbedContent":"style_tabbedContent--fKDcBGah","basic-text-page":"style_basic-text-page--2s6u5D1K","basicTextPage":"style_basic-text-page--2s6u5D1K","social-media-holder":"style_social-media-holder--3M9GbeHQ","socialMediaHolder":"style_social-media-holder--3M9GbeHQ"};


//////////////////
// WEBPACK FOOTER
// ./components/info-page/src/styles/style.scss
// module id = 106
// module chunks = 0